module.exports = __webpack_public_path__ + "img/9788983947055.a1826cc2.jpg";